import { Star } from "lucide-react";

const PLACE_ID = "ChIJVZdUUfuZpgARCi4r2RDRO2s";
const REVIEWS_URL = `https://www.google.com/maps/search/?api=1&query=Atacado%20%C3%93ptico&query_place_id=${PLACE_ID}`;

export default function GoogleMerchantBadge() {
  return (
    <a
      href={REVIEWS_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 left-6 z-40 inline-flex items-center gap-2 rounded-full bg-white shadow-lg border border-gray-100 px-3 py-2 transition-transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-primary min-h-[44px]"
      aria-label="Ver avaliações da loja no Google Meu Negócio"
    >
      <span className="flex items-center justify-center w-6 h-6 rounded-full bg-blue-50">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          className="h-4 w-4"
          aria-hidden="true"
        >
          <path
            d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
            fill="#4285F4"
          />
          <path
            d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
            fill="#34A853"
          />
          <path
            d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
            fill="#FBBC05"
          />
          <path
            d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
            fill="#EA4335"
          />
        </svg>
      </span>
      <span className="flex flex-col leading-none">
        <span className="text-[10px] text-muted-foreground">Avaliações Google</span>
        <span className="flex items-center gap-1 text-sm font-semibold text-foreground">
          <Star className="h-3.5 w-3.5 fill-amber-400 text-amber-400" aria-hidden="true" />
          Qualidade da Loja
        </span>
      </span>
    </a>
  );
}
